import { Map, List } from 'immutable'
import { set } from 'utils/immutable'

import {
  HARNESSES_SUCCESS,
  ADD_HARNESS,
  REMOVE_HARNESS,
  RESET_HARNESSES,
} from 'actions/feature/harnesses'

export default {
  [HARNESSES_SUCCESS]: setHarnessesData,
  [ADD_HARNESS]: addHarness,
  [REMOVE_HARNESS]: removeHarness,
  [RESET_HARNESSES]: resetHarnesses,
}

function setHarnessesData(state, { data: { entities } }) {
  const { modules, harnesses, pins } = entities

  const setHarnesses = set('harnesses', { harnesses, modules, pins })

  return setHarnesses(state)
}

function addHarness(state, { harnessId }) {
  const featureId = getFeatureId(state)

  return state.updateIn(
    ['currentFeature', 'feature', featureId, 'harnesses'],
    (harnesses) => {
      const [partNumber, revision] = harnessId.split('+')

      const items = harnesses || List() // harness object may not exist on feature yet
      return items.push(
        Map({
          partNumber,
          revision: revision || '-',
        })
      )
    }
  )
}

function removeHarness(state, { harnessId }) {
  const featureId = getFeatureId(state)

  return state.updateIn(
    ['currentFeature', 'feature', featureId, 'harnesses'],
    (harnesses) => {
      const [partNumber, revision] = harnessId.split('+')

      return harnesses.filterNot((harness) => {
        const harnessPartNumber = harness.get('partNumber')
        const harnessRevision = harness.get('revision')

        const partNumbersEq = harnessPartNumber === partNumber
        const revisionsEq = revision
          ? harnessRevision === revision
          : harnessRevision === '-'

        return partNumbersEq && revisionsEq
      })
    }
  )
}

function resetHarnesses(state) {
  const featureId = getFeatureId(state)
  return state.setIn(
    ['currentFeature', 'feature', featureId, 'harnesses'],
    List()
  )
}

const getFeatureId = (state) =>
  state.getIn(['currentFeature', 'feature']).first().get('id')
